import request from '@/axios/customerManager'
import uploadRequest from '@/axios/upload'
import axios from 'axios'

// m-01-获取客户经理服务数据计数
export function getManagerBusinessCount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getManagerBusinessCount',
    method: 'post',
    data
  })
}

// 01-获取门店列表
export function getStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStoreList',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// S-01-获取消息列表
export function getMessageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/getMessageList',
    method: 'post',
    data
  })
}
// 综合数据分析
export function getIntegratedAnalysis(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getIntegratedAnalysis',
    method: 'post',
    data
  })
}
// 03-切换当前门店
export function changeStore(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/changeStore',
    method: 'post',
    data
  })
}
// 业绩数据分析
export function getPerformanceAnalysis(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getPerformanceAnalysis',
    method: 'post',
    data
  })
}
// 用户下订周期
export function getOrderPeriodAnalysis(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getOrderPeriodAnalysis',
    method: 'post',
    data
  })
}
// S-03-读取消息
export function readMessageInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/readMessageInfo',
    method: 'post',
    data
  })
}
// S-05-更新消息为已读状态
export function updateMessageStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/message/updateMessageStatus',
    method: 'post',
    data
  })
}

// G-02-流程订单列表
export function getProcessOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getProcessOrderList',
    method: 'post',
    data
  })
}

// B-14-获取服务岗位员工列表
export function getStationStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getStationStaffList',
    method: 'post',
    data
  })
}

// 获取服务岗位员工列表 全公司
export function getRolesStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getAllStaffList',
    method: 'post',
    data
  })
}

// G-03-订单转设计师详情
export function getDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/designer/getDesigner',
    method: 'post',
    data
  })
}

// 12-获取小区
export function getVillageList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getVillageList',
    method: 'post',
    data
  })
}

// G-0301-订单转设计师提交
export function saveDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/designer/saveDesigner',
    method: 'post',
    data
  })
}

// O-01-到店确认列表
export function preCustomerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/preCustomerList',
    method: 'post',
    data
  })
}

// G-01-全部订单列表
export function getAllList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getAllList',
    method: 'post',
    data
  })
}
// 17-获取预上门客户信息
export function getPreCustomerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/getPreCustomerInfo',
    method: 'post',
    data
  })
}

// 01-创建销售机会
export function saveOpportunity(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity/saveOpportunity',
    method: 'post',
    data
  })
}

// 04-获取选项字段选择下拉列表
export function getSelectFieldOption(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSelectFieldOption',
    method: 'post',
    data
  })
}

// 09-获取房屋类型
export function getHouseTypeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getHouseTypeList',
    method: 'post',
    data
  })
}

// 10-获取房屋状态类型
export function getHouseStatusList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getHouseStatusList',
    method: 'post',
    data
  })
}

// 18-获取线下渠道列表
export function getOfflineChannel(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getChannelList',
    method: 'post',
    data: {
      ...data,
      channel_label_id: '50'// 自主上门渠道标签id
    }
  })
}

// G-0806-查询当前门店下手机号是否已经下订
export function QueryMobile(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/QueryMobile',
    method: 'post',
    data
  })
}
// 02-获取销售机会列表
export function getOpportunityList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity/getOpportunityList',
    method: 'post',
    data
  })
}

// G-1102-获取订单订金单详情
export function getOrderDepositInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/getOrderDepositInfo',
    method: 'post',
    data
  })
}
// 05-获取跟进类型选项
export function getFollowTypeList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getFollowTypeList',
    method: 'post',
    data
  })
}
// G-1103-订单转大定提交(新)
export function changeToBigDeposit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/changeToBigDeposit',
    method: 'post',
    data
  })
}

// G-1104-订单重新收款
export function resetReceipt(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/resetReceipt',
    method: 'post',
    data
  })
}

// B-15-获取门店产品包分类
export function getStorePackageCategory(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/product_package/getStorePackageCategory',
    method: 'post',
    data
  })
}

// B-16-获取门店包列表
export function getStoreProductPackage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/product_package/getStoreProductPackage',
    method: 'post',
    data
  })
}

// 下订详情
export function getOrderDetails(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getOrderDetails',
    method: 'post',
    data
  })
}

// 下订详情
export function getOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getOrder',
    method: 'post',
    data
  })
}

// 下订
export function saveOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/saveOrder',
    method: 'post',
    data
  })
}
// 快速下订
export function quickOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity/quickOrder',
    method: 'post',
    data
  })
}
// 用支付序号查询支付信息
export function getOrderAmountInfoById(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountInfoById',
    method: 'post',
    data
  })
}

export function getOrderAmountId(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountInfo',
    method: 'post',
    data
  })
}

// 获取门店包列表
export function buildCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/buildCode',
    method: 'post',
    data
  })
}

// 发送付款码
export function sendAmountImage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/sendAmountImage',
    method: 'post',
    data
  })
}

// 获取实名认证地址
export function authent(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/user/user/authent',
    method: 'post',
    data
  })
}

// 报价单收款
export function receiptAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer_receipt/receiptAmount',
    method: 'post',
    data
  })
}
// 03-销售就会跟进接口
export function saveOpportunityFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity_follow/saveOpportunityFollow',
    method: 'post',
    data
  })
}
// 05-获取订单列表
export function getOrderList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getOrderList',
    method: 'post',
    data
  })
}
// 01-添加退款单(新)
export function saveRefundAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/saveRefundAmount',
    method: 'post',
    data
  })
}
export function getChangeItems(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getChangeItems',
    method: 'post',
    data
  })
}
export function appletWeChatCode(data) {
  return axios({
    url: process.env.VUE_APP_BASE_WEIXIN_MP + '/index/wechat/appletWeChatCode',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 0501-手机号获取订单状态
export function getOrderStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getOrderStatus',
    method: 'post',
    data
  })
}
// G-1101-获取订单订金单列表
export function getOrderDepositList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/getOrderDepositList',
    method: 'post',
    data
  })
}
// A-08-客户经理播报
export function getBroadcastAnalysis(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/getBroadcastAnalysis',
    method: 'post',
    data
  })
}
// CM-03-需求录入确认
export function confirm(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/confirm',
    method: 'post',
    data
  })
}
// CM-03-获取监理和经理服务岗位员工列表
export function getSupervisionStaffList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSupervisionStaffList',
    method: 'post',
    data
  })
}

// CM-01-初步需求评估列表
export function getDemandsList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getDemandsList',
    method: 'post',
    data
  })
}
// CM-02-用户档案
export function customerInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/customerInfo',
    method: 'post',
    data
  })
}
// 27-设计服务空间列表
export function getSpaceList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getSpaceList',
    method: 'post',
    data
  })
}
// CM-04-获取成员
export function getMembers(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getMembers',
    method: 'post',
    data
  })
}
// 29-获取性格倾向
export function getCharacterTrend(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getCharacterTrend',
    method: 'post',
    data
  })
}
// A-09-勘测邀请列表
export function getMeasureInviteList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getMeasureInviteList',
    method: 'post',
    data
  })
}
// G-05-待勘测订单详情
export function getMetering(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/no_signed/getMetering',
    method: 'post',
    data
  })
}
// 0202-(新)添加勘测邀请
export function addInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/addInvite',
    method: 'post',
    data
  })
}
// 03-获取勘测邀请函
export function getMeasureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/getMeasureInvite',
    method: 'post',
    data
  })
}
// 04-客户确认勘测邀请
export function determineMeasure(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/measure/measure/determineMeasure',
    method: 'post',
    data
  })
}
// CM-05-修改协作
export function editDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/editDesigner',
    method: 'post',
    data
  })
}
// A-11-(rad1)创建需求邀请
export function addDemandInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/addDemandInvite',
    method: 'post',
    data
  })
}
// A-10-(rad1)初步需求邀请列表
export function getDemandInviteList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getDemandInviteList',
    method: 'post',
    data
  })
}
// (rad1)-06-邀请涵详情
export function getInviteInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getInviteInfo',
    method: 'post',
    data
  })
}
// A-12-(rad1)-删除邀请函
export function delInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/delInvite',
    method: 'post',
    data
  })
}
// A-13-查看是否完成需求确认
export function getOpportunityAffirmStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getOpportunityAffirmStatus',
    method: 'post',
    data
  })
}
// 06-获取销售机会输单原因列表
export function getOpportunityLoseReason(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getOpportunityLoseReason',
    method: 'post',
    data
  })
}
// 04-销售机会输单接口
export function loseOpportunity(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity/loseOpportunity',
    method: 'post',
    data
  })
}

// CM-01-关键数据统计
export function keyDataStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/keyDataStatistics',
    method: 'post',
    data
  })
}

// CM-02-面谈量统计
export function interviewStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/interviewStatistics',
    method: 'post',
    data
  })
}

// CM-03-关键动作统计
export function keyActionStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/keyActionStatistics',
    method: 'post',
    data
  })
}

// CM-04-上门订单类型统计
export function orderTypeStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/orderTypeStatistics',
    method: 'post',
    data
  })
}

// CM-05-上门接待时长统计
export function timeStatistics(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/analysis/timeStatistics',
    method: 'post',
    data
  })
}

// CM-08-门店客户经理列表
export function managerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/store_manager/managerList',
    method: 'post',
    data
  })
}

// CM-06-讲解中数据
export function getExplainCustomer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getExplainCustomer',
    method: 'post',
    data
  })
}

// CM-06-讲解中数据
export function getOverStoreInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/manager_pad/explain_function/getOverStoreInfo',
    method: 'post',
    data
  })
}

// CM-07-离店提醒内容
export function leaveNoticeMessage(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/leaveNoticeMessage',
    method: 'post',
    data
  })
}

// 02-获取门店信息
export function getStoreDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStoreDetail',
    method: 'post',
    data
  })
}
// H-02-获取订单相关基础信息
export function getOrderInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/offer/offer/getOrderInfo',
    method: 'post',
    data
  })
}
// (新)CM-01-用户下订
export function getCustomers(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getCustomers',
    method: 'post',
    data
  })
}
// (新)CM-02-跟进用户列表
export function getFollowList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getFollowList',
    method: 'post',
    data
  })
}
// (新)CM-03-今日需跟进列表
export function getTodayFollowList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getTodayFollowList',
    method: 'post',
    data
  })
}
// (新)CM-04-待转设计师列表
export function getDesignedList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getDesignedList',
    method: 'post',
    data
  })
}
// (新)CM-05-标记无效上门
export function invalidVisit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/invalidVisit',
    method: 'post',
    data
  })
}
// (新)CM-06-订单列表
export function getOrderListContinue(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getOrderList',
    method: 'post',
    data
  })
}
// 16-预上门客户未到店
export function noVisit(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/noVisit',
    method: 'post',
    data
  })
}
// 16-预上门客户未到店
export function getOrderAmountList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/getOrderAmountList',
    method: 'post',
    data
  })
}

// (新)CM-06-获取门店店长
export function getStoreManager(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/staff/staff_store/getStoreManager',
    method: 'post',
    data
  })
}
// (新)CM-06-创建预售合同提交
export function savePresaleContract(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_contract/savePresaleContract',
    method: 'post',
    data
  })
}
// (新)CM-08跟进用户详情
export function getFollowDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getFollowDetail',
    method: 'post',
    data
  })
}
// M-获取收款单详情
export function getOrderAmountInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/ordetOrderAmountInfo',
    method: 'post',
    data
  })
}
// M-获取收款单详情
export function closeAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/closeAmount',
    method: 'post',
    data
  })
}
// G-9001-订单详情-基本信息
export function getBaseOrderDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_detail/getBaseOrderDetail',
    method: 'post',
    data
  })
}
// 28-发送验证码
export function sendSmsCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/tools/sendSmsCode',
    method: 'post',
    data
  })
}
// 03-获取退款单详情
export function getRefundAmountInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getRefundAmountInfo',
    method: 'post',
    data
  })
}

// 2-发起审批
export function saveApprovalInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/approval/refund_amount_approval/saveApprovalInfo',
    method: 'post',
    data
  })
}
// (新)CM-09-签预售下订
export function savePresaleOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/savePresaleOrder',
    method: 'post',
    data
  })
}
// 08-获取销售机会基本信息
export function getBaseOpportunityInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity/getBaseOpportunityInfo',
    method: 'post',
    data
  })
}
// 10-获取房屋信息
export function getHouseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/house/house/getHouseInfo',
    method: 'post',
    data
  })
}
// G-1103-订单签预售
export function changeToPresale(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/changeToPresale',
    method: 'post',
    data
  })
}
// (新)CM-10-用户列表
export function getCustomerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getCustomerList',
    method: 'post',
    data
  })
}
// G-1103-签预售
export function savePreSale(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_deposit/savePreSale',
    method: 'post',
    data
  })
}
// 14-编辑房屋信息
export function editHouseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/house/house/editHouseInfo',
    method: 'post',
    data
  })
}

// 14-编辑房屋类型信息
export function editHouseStatusInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/house/house/editHouseStatusInfo',
    method: 'post',
    data
  })
}

// 添加收款凭证
export function saveOrderAmountResource(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_amount/saveOrderAmountResource',
    method: 'post',
    data
  })
}

// 2-发起审批
export function saveApproval(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/approval/amount_approval/saveApprovalInfo',
    method: 'post',
    data
  })
}

// 1-获取收款审批信息
export function getApprovalInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/approval/amount_approval/getApprovalInfo',
    method: 'post',
    data
  })
}

// 21-获取门店配置信息
export function getStoreConfiguration(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getStoreConfiguration',
    method: 'post',
    data
  })
}
// 1701-判断手机号是否上门
export function getOpportunityStatus(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/getOpportunityStatus',
    method: 'post',
    data
  })
}

export function getLoseReasonList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getLoseReasonList',
    method: 'post',
    data
  })
}

// 获取订单可退款金额
export function getMayRefundAmount(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order_refund_amount/getMayRefundAmount',
    method: 'post',
    data
  })
}

// 获取客户经理跟进历史记录
export function getOpportunityFollowHistory(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity_follow/getOpportunityFollowHistory',
    method: 'post',
    data
  })
}

// 获取客户经理跟进节点数据
export function getFollowProcessList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/opportunity_follow/getFollowProcessList',
    method: 'post',
    data
  })
}

// 今日需跟进列表
export function getFollowDesignerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getFollowList',
    method: 'post',
    data
  })
}
// 跟进订单记录（设计师）
export function getFollowRecord(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getFollowRecord',
    method: 'post',
    data
  })
}
// 获取设计师跟进节点数据
export function getFollowProcessDesignerList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/getFollowProcessList',
    method: 'post',
    data
  })
}
// 添加跟进（设计师）
export function addDesignerFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/designer/addFollow',
    method: 'post',
    data
  })
}

// 17-预上门客户预案详情
export function getScheme(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/getScheme',
    method: 'post',
    data
  })
}

// 18-预上门客户添加预案
export function addPreScheme(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/plan_visit_customer/addPreScheme',
    method: 'post',
    data
  })
}

// (优惠劵)G-02-获取可用优惠劵列表
export function getCouponList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/order/getCouponList',
    method: 'post',
    data
  })
}

// 04-获取销售机会标签列表
export function getFollowLabelList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/follow/getFollowLabelList',
    method: 'post',
    data
  })
}

// 01-创建销售机会分析策略&有效未下订离店(pad 门店端)
export function saveAnalyse(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/follow/saveAnalyse',
    method: 'post',
    data
  })
}

// 02-销售机会二次要约
export function inviteCustomer(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/follow/inviteCustomer',
    method: 'post',
    data
  })
}

// 03-获取销售机会分析详细
export function getAnalyseInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/follow/getAnalyseInfo',
    method: 'post',
    data
  })
}

// 05-获取销售机会未下订原因列表
export function getNotOrderReasonList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/opportunity/follow/getNotOrderReasonList',
    method: 'post',
    data
  })
}

// (new)02-个性化需求点
export function getPersonalDemand(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/getPersonalDemand',
    method: 'post',
    data
  })
}

// (rad1)-02-获取选项（0723）
export function getSelectOperation(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/rad_one/getSelectOperation',
    method: 'post',
    data
  })
}

// 未定原因列表
export function opportunityNotOrderReason(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/base/select_option/opportunityNotOrderReason',
    method: 'post',
    data
  })
}

// 获取待离店列表(2106)
export function getOverStoreList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getOverStoreList',
    method: 'post',
    data
  })
}

// AI 工作流任务初始化
export function getAiWorkflowTaskInitInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/ai/workflow_task/init',
    method: 'post',
    data
  })
}

// 创建 AI 工作流任务
export function createAiWorkflowTask(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/ai/workflow_task/create',
    method: 'post',
    data
  })
}

// 获取 AI 工作流任务详情
export function getAiWorkflowTaskDetail(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/ai/workflow_task/detail',
    method: 'post',
    data
  })
}

// 重试 AI 工作流任务
export function retryAiWorkflowTask(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/ai/workflow_task/retry',
    method: 'post',
    data
  })
}

// AI 工作流任务文件上传
export function uploadAiWorkflowTaskFile(file, data) {
  const param = new FormData()
  param.append('file', file)
  if (data) {
    Object.keys(data).forEach(element => {
      param.append(element, data[element])
    })
  }
  return uploadRequest({
    url: '//upload.qiniup.com',
    method: 'post',
    data: param,
    config: {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  })
}

// B-14-获取服务岗位员工列表
export function planMeasure(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/design_process/planMeasure',
    method: 'post',
    data
  })
}

// 勘测邀约
export function measureInvite(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/design_process/measureInvite',
    method: 'post',
    data
  })
}

// 勘测邀约
export function planAlteration(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/design_process/planAlteration',
    method: 'post',
    data
  })
}

// 获取未签约原因
export function getNotSignReason(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/getNotSignReason',
    method: 'post',
    data
  })
}

// 提交订单跟进
export function saveFollow(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/saveFollow',
    method: 'post',
    data
  })
}

export function getFollowInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/follow/getFollowInfo',
    method: 'post',
    data
  })
}

// (店长)设计资料上传
export function materialUploading(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/order/design_process/materialUploading',
    method: 'post',
    data
  })
}

// 07-获取无效上门原因
export function getValidReason(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/workbench/manager/getValidReason',
    method: 'post',
    data
  })
}

// 顾问转设计师
export function transferDesigner(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/funnel/transferDesigner',
    method: 'post',
    data
  })
}

// 顾问转设计师详情
export function getDesignerTime(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/customer/funnel/getDesignerTime',
    method: 'post',
    data
  })
}
